export default "__VITE_ASSET__DNKX_QHC__"